
export interface FileInputEvent extends Event {
  target: HTMLInputElement;
}

interface MP4BoxInfo {
  videoTracks: { codec: string }[];
}

interface MP4BoxFile {
  onError: (error: Error) => void;
  onReady: (info: MP4BoxInfo) => void;
  appendBuffer(buffer: ArrayBuffer): void;
  flush(): void;
}

declare const MP4Box: {
  createFile(): MP4BoxFile;
};

interface BufferWithFileStart extends ArrayBuffer {
  fileStart: number;
}

export const validateFile = (
  event: FileInputEvent,
  file: File
): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    if (!event.target.files || event.target.files.length === 0) {
      alert("No file selected.");
      resolve(false);
      return;
    }
    const { name } = event.target.files[0];
    const extension = (
      name.substring(name.lastIndexOf(".") + 1, name.length) || name
    ).toLowerCase();

    if (extension !== "mp4" && extension !== "mov" && extension !== "webm") {
      alert(
        "The file you selected is not the correct type. Please choose an MP4 or MOV video file."
      );
      resolve(false);
    } else if (extension !== "webm") {
      // Prevent uploading an H265-encoded video

      const fileReader = new FileReader();

      fileReader.readAsArrayBuffer(file);

      fileReader.addEventListener("load", (e: ProgressEvent<FileReader>) => {
        const buffer = fileReader.result as BufferWithFileStart;

        buffer.fileStart = 0;
        const mp4boxfile = MP4Box.createFile();

        mp4boxfile.onError = () => {
          reject(new Error("An error has occurred processing your video."));
        };

        mp4boxfile.onReady = (info: MP4BoxInfo) => {
          const codecPrefixes = info.videoTracks.map((track) => {
            return track.codec.slice(0, 3);
          });

          if (codecPrefixes.includes("hvc") || codecPrefixes.includes("hev")) {
            reject(
              new Error(
                "Video codec h265 is not supported. Please convert to h264 before uploading."
              )
            );
          } else {
            resolve(true);
          }
        };
        mp4boxfile.appendBuffer(fileReader.result as ArrayBuffer);
        mp4boxfile.flush();
      });
    } else {
      resolve(true);
    }
  });
};
